<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="Donation Amount">
                    <div style="position:relative">
                        <AmountSelector/>                    
                        <ErrorLabel field="amount"  style="text-align:right"/>
                    </div>                    
                </FormSection>
                <FormSection v-if="form.amount">
                  <TransactionFee />
                </FormSection>  
                <FormSection title="Donation Frequency">
                 <div class="frequency">
                      <PaymentOptions addMonthly addSplit monthesSelector/>
                    </div>
                </FormSection>              
                <FormSection title="Personal Information">
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>                           
                </FormSection>   
                 <FormSection title="">
                  <InHonorOf />   
                </FormSection>         
                <FormSection title="NCSY Region">
                  <FormRow inline>
                      <FormSelect field="custom.region" class="width-half" style="margin-right:10px;">
                      <option value="" disabled selected hidden>Choose Your Region</option>
                        <option selected="selected" value="Ashrei Region">Ashrei Region</option>
                        <option value="Atlanta NCSY">Atlanta NCSY</option>
                        <option value="Atlantic Seaboard">Atlantic Seaboard</option>
                        <option value="Atlantic Seaboard NCSY">Atlantic Seaboard NCSY</option>
                        <option value="Camp Sports">Camp Sports</option>
                        <option value="Canada NCSY">Canada NCSY</option>
                        <option value="Central East NCSY">Central East NCSY</option>
                        <option value="Etz Chaim">Etz Chaim</option>
                        <option value="Har Sinai NCSY">Har Sinai NCSY</option>
                        <option value="Heart to Heart">Heart to Heart</option>
                        <option value="ICE Israel">ICE Israel</option>
                        <option value="JLIC Binghamton">JLIC Binghamton</option>
                        <option value="JOLT">JOLT</option>
                        <option value="Long Island NCSY">Long Island NCSY</option>
                        <option value="Midwest NCSY">Midwest NCSY</option>
                        <option value="National NCSY">National NCSY</option>
                        <option value="NCSY BILT">NCSY BILT</option>
                        <option value="NCSY Canada">NCSY Canada</option>
                        <option value="NCSY Euro ICE">NCSY Euro ICE</option>
                        <option value="NCSY GIVE">NCSY GIVE</option>
                        <option value="NCSY GIVE USA">NCSY GIVE USA</option>
                        <option value="NCSY Give West">NCSY Give West</option>
                        <option value="NCSY Kollel">NCSY Kollel</option>
                        <option value="NCSY Michlelet">NCSY Michlelet</option>
                        <option value="New England NCSY">New England NCSY</option>
                        <option value="New Jersey NCSY">New Jersey NCSY</option>
                        <option value="New York NCSY">New York NCSY</option>
                        <option value="NJ NCSY">NJ NCSY</option>
                        <option value="NorCal NCSY">NorCal NCSY</option>
                        <option value="Northwest">Northwest</option>
                        <option value="Southern NCSY">Southern NCSY</option>
                        <option value="Southwest NCSY">Southwest NCSY</option>
                        <option value="Summer Programs">Summer Programs</option>
                        <option value="TJJ">TJJ</option>
                        <option  value="TJJ Ambassadors">TJJ Ambassadors</option>
                        <option value="Upstate New York NCSY">Upstate New York NCSY</option>
                        <option value="West Coast NCSY">West Coast NCSY</option>
                        <option value="None">None</option>
                        <option value="Other">Other</option>
                      </FormSelect>
                      <FormInput class="width-half" field="custom.otherRegion" v-if="getValue('custom.region') == 'Other'"/>
                    </FormRow>
                    <br>
										<FormRow>
												<FormLabel class="control-label">
													Honor Your Favorite Advisor (optional)
											</FormLabel>
										</FormRow>									
										<FormRow>
											<FormInput type="text" class="width-half" field="custom.honor" placeholder="Advisor Name"/>                              
										</FormRow>  
                  <br>
										<FormRow>
												<FormLabel class="control-label">
													 NCSY/High School Graduation Class
											</FormLabel>
										</FormRow>									
										<FormRow>
                      <FormSelect field="custom.graduation" class="width-half" style="margin-right:10px;">
                        <option value="" disabled selected hidden>Choose Your Year</option>
                          <option value="2022">2022</option>
                          <option value="2021">2021</option>
                          <option value="2020">2020</option>
                          <option value="2019">2019</option>
                      </FormSelect>                          
										</FormRow> 
                    <br>
									<FormRow>
												<FormLabel class="control-label">
												College Graduation Year (optional)
											</FormLabel>
										</FormRow>									
										<FormRow>
                        <FormInput type="text" class="width-half" field="custom.collegeGraduation" placeholder="College Graduation Year"/>                            
										</FormRow>  
                    <br>
									<FormRow>
												<FormLabel class="control-label">
												Favorite NCSY Memory (optional)
											</FormLabel>
										</FormRow>									
										<FormRow>
                       <FormInput type="textarea" class="width-half" field="custom.memory"/>                       
										</FormRow>                                                             
                </FormSection>                         
                <FormSection title="Billing Information">
                    <DonorAddress />
                </FormSection>
                <FormSection title="Payment Information" last>
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false"/>
                    </FormRow>
                </FormSection>
                <PaymentButton  btnText="Donate Now"/>
            </PaymentForm>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  setup() {
    const { setValue, form, getValue } = usePaymentForm()

    return {
      form,
      getValue,
      setValue
    }
  },
})
</script>
<style scoped lang="scss">
::v-deep h2 {
  color: #1AA8D3;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 25px;
}

::v-deep .form-container.ou-donation-form{
  max-width: 100%;
}
::v-deep .styled-radio-container--ou-donation.styled-radio-container input[type="radio"]:checked + label{
  background: #1AA8D3;
}
::v-deep hr {
    background: none;
    box-shadow: none;
    height: 0;
    border: none;
    margin-bottom: 20px;
    border-bottom: 1px solid #efefef;
}
</style>

